import {Button} from '@tkww/orion-web-ds-action';
import {TextTitle, TextBody} from '@tkww/orion-web-ds-text';
import React from 'react';
import {TK_HOST} from '../../constants/app';
import styles from './index.scss';

const ErrorPage = () => {
  return (
    <>
      <div
        data-testid="error-page-container"
        className={styles['img-container']}>
        <img
          className={styles['error-image']}
          src="https://media-api.xogrp.com/images/0f096460-a41b-4275-b7c7-b7f74d89f6e9"
          alt=""
        />
      </div>
      <div
        data-testid="error-page-info-section"
        className={styles['info-section']}>
        <TextTitle size="lg" as="h1">
          The Connection Has Timed Out
        </TextTitle>

        <TextBody size="md" className={styles['body-text']}>
          The server encountered a temporary error and could not complete your
          request. Please try again in a few moments.
        </TextBody>

        <Button
          as="a"
          className={styles['continue-shopping-link']}
          href="/registry/store/categories/kitchen"
          size="lg"
          styleType="secondary">
          Continue Shopping
        </Button>

        <TextBody size="sm" className={styles['questions-text']}>
          Feeling lost? We’ve got you. Find a
          <a href={`${TK_HOST}/registry/couplesearch`}> Wedding Website </a>
          or <a href={`${TK_HOST}/registry/couplesearch`}> Registry</a>, check
          out our
          <a href="https://helpcenter.theknot.com/hc/en-us"> FAQ </a>or
          <a href="mailto:registryhelp@theknot.com"> get in touch</a>.
        </TextBody>
      </div>
    </>
  );
};

export default ErrorPage;
